<template>
  <b-modal id="modal-config-retries" v-model="modal" size="lg" hide-footer>
    <template #modal-title
      >CONFIGURAR PUNTOS DE REINTENTOS SOBRE {{ amountBills }}</template
    >
    <vs-button type="button" success class="mb-3" @click="addConfig">
      AGREGAR CONFIG <span class="ms-2 uil-plus text-light"></span>
    </vs-button>
    <div class="grid-config-retries">
      <span>DESDE</span>
      <span>HASTA</span>
      <span>PUNTOS</span>
    </div>
    <div class="grid-config-retries" v-for="(item, i) in retries" :key="i">
      <vs-input
        class="mb-2 shadow-lg"
        border
        placeholder="DESDE"
        v-model="item.from"
      />
      <vs-input
        class="mb-2 shadow-lg"
        border
        placeholder="DESDE"
        v-model="item.to"
      />
      <vs-input
        class="mb-2 shadow-lg"
        border
        placeholder="PUNTOS"
        v-model="item.percentage"
      />
      <div class="d-flex align-items-center">
        <vs-button type="button" success @click="() => save(item)">
          <span class="uil-check text-light"></span>
        </vs-button>
        <vs-button type="button" @click="() => remove(item)">
          <span class="uil-trash-alt text-light"></span>
        </vs-button>
        <span>{{ getTotalPercentage(item.percentage) }}%</span>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    amountBills: {
      type: Number,
      default: 2000,
    },
  },
  data() {
    return {
      modal: false,
      tournament: null,
      retries: [
        {
          id: 'mock-1',
          from: 1,
          to: 10,
          percentage: 85,
          tournament: 'mock-tournament',
        },
      ],
    };
  },
  computed: {
    getTotalPercentage() {
      return function (number) {
        return (number * 100) / this.amountBills;
      };
    },
    ...mapGetters({
      success: 'tournaments/isSuccess',
      title: 'tournaments/getMessage',
    }),
  },
  methods: {
    closeModa() {
      this.modal = false;
    },
    addConfig() {
      this.retries.push({
        from: 0,
        to: 0,
        percentage: 0,
        id: `mock-${this.retries.length + 1}`,
      });
    },
    async save(item) {
      console.log('item', item);
      if (this.getTotalPercentage(Number(item.percentage)) > 100) {
        this.$swal.fire({
          title: 'Error',
          text: 'El porcentaje no puede ser mayor al 100%',
          icon: 'error',
        });
        return;
      }

      const retries = {
        ...item,
        tournament: this.tournament,
      };

      if (item.id.startsWith('mock-')) {
        await this.createRetries({ retries });
      } else {
        await this.updateRetries({ retries });
      }

      if (this.success) {
        this.$swal.fire({
          title: this.title,
          icon: 'success',
          timer: 2000,
        });
        this.closeModa();
      } else {
        this.$swal.fire({
          title: this.title,
          icon: 'error',
          timer: 2000,
        });
      }
    },
    async remove(item) {
      const { isConfirmed } = await this.$swal.fire({
        title: '¿Estás seguro?',
        text: '¿Deseas eliminar este reintento?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });

      if (!isConfirmed) return;

      if (item.id.startsWith('mock-')) {
        this.retries = this.retries.filter((i) => i.id !== item.id);
        return;
      }

      await this.deleteRetries(item.id);
      if (this.success) {
        this.$swal.fire({
          title: this.title,
          icon: 'success',
          timer: 2000,
        });

        this.retries = this.retries.filter((i) => i.id !== item.id);
      } else {
        this.$swal.fire({
          title: this.title,
          icon: 'error',
          timer: 2000,
        });
      }
    },
    ...mapActions({
      createRetries: 'tournaments/createRetries',
      updateRetries: 'tournaments/updateRetries',
      deleteRetries: 'tournaments/deleteRetries',
    }),
  },
};
</script>

<style lang="scss" scoped>
.grid-config-retries {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  padding: 10px;
}
</style>
